import { useShallow } from "zustand/shallow";

import { useBoundStore } from "@/app/store";
import { FetchedTag } from "@/services/api/fetchers/tags";
import { DrawerAndModal } from "@/shared/components/common/DrawerAndModal";
import { ConfirmDeleteTagContent } from "./ConfirmDeleteTagContent";

interface ConfirmDeleteTagProps {
  id: string;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  tag?: FetchedTag | null;
  onConfirm: () => void;
}

export function ConfirmDeleteTag({ id, tag, isOpen, onConfirm, onOpenChange }: ConfirmDeleteTagProps) {
  const { deviceType } = useBoundStore(useShallow((state) => ({ deviceType: state.device.type })));
  const title = "Delete Tag";

  return (
    <DrawerAndModal
      closeLabel="Cancel"
      confirmLabel="Delete"
      id={id}
      title={title}
      externalState={{ isOpen, onOpenChange }}
      onConfirm={onConfirm}
    >
      <ConfirmDeleteTagContent tag={tag} onConfirm={onConfirm} onOpenChange={onOpenChange} deviceType={deviceType} />
    </DrawerAndModal>
  );
}
